import { IUpdateForUserSettingsAccepted } from '../../../actions/userObject/settings/requestUpdateUserSettings'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IUpdateForUserSettingsAccepted,
): IUserObjectStore {
  return {
    ...state,
    settingsRequest: {
      ...state.settingsRequest,
      isLoading: false,
      isSaving: false,
    },
    userObject: {
      ...state.userObject,
      settings: {
        ...state.userObject.settings,
        ...action.settings,
      },
    },
  }
}
